export const users = [
  {
    name: "John Doe",
    email: "johndoe@gmail.com",
    role: "Super Admin",
    phone: "0240000000",
    status: "Active",
    id: 1,
  },
  {
    name: "Fred Adu",
    email: "fredadu@gmail.com",
    phone: "0240000000",
    role: "Inputer",
    status: "Inactive",
    id: 2,
  },
];

export const roles = [
  {
    id: 1,
    name: "Super Admin",
    assigned: 5,
    active: true,
    priviledges: {
      MANAGE_USER: true,
      MANAGE_ROLE: true,
      MANAGE_CTE: true,
      DASHBOARD: true,
      DATA_ENTRY: false,
      HISTORY: true,
    },
  },
  {
    id: 2,
    name: "Inputer",
    assigned: 10,
    active: true,
    priviledges: {
      MANAGE_USER: false,
      MANAGE_ROLE: false,
      MANAGE_CTE: false,
      DASHBOARD: true,
      DATA_ENTRY: true,
      HISTORY: true,
    },
  },
  {
    id: 3,
    name: "Observer",
    assigned: 10,
    active: false,
    priviledges: {
      MANAGE_USER: false,
      MANAGE_ROLE: false,
      MANAGE_CTE: false,
      DASHBOARD: false,
      DATA_ENTRY: false,
      HISTORY: true,
    },
  },
  {
    id: 4,
    name: "Staff",
    assigned: 10,
    active: false,
    priviledges: {
      MANAGE_USER: false,
      MANAGE_ROLE: false,
      MANAGE_CTE: false,
      DASHBOARD: true,
      DATA_ENTRY: false,
      HISTORY: true,
    },
  },
];

export const products = [
  {
    id: 1,
    name: "Cashew 1",
    assigned_traceability: "Cashew Traceability Flow",
    active: true,
  },
  {
    id: 2,
    name: "Cocoa ",
    assigned_traceability: "Cocoa Trace 2",
    active: false,
  },
];

export const flows = [
  {
    id: 1,
    name: "Rosswood Cashew Flow",
    observers: ["John Doe", "Fred Adu"],
    product: "Cashew",
  },
  {
    id: 2,
    name: "Rosswood Cocoa Flow",
    observers: ["John Doe", "Fred Adu"],
    product: "Cocoa",
  },
];

export const ctes = [
  {
    id: 1,
    name: "CTE 1",
    assigned_kdes: [
      {
        label: "KDE 1",
        name: "KDE 1",
        type: "input text",
        isRequired: true,
        placeholder: "Enter KDE 1",
        options: [],
        helperText: "Enter KDE 1",
      },
    ],
    assigned_users: ["John Doe", "Fred Adu"],
  },
];

export const history = [
  {
    id: 1,
    batch_number: "ES-23-131",
    product: "Cashew",
    status: "Active",
    date: "2023-11-18",
    flow: "Rosswood Cashew Flow",
  },
];

export const traceHistory = [
  {
    cte: "Buying from farmer",
    assigned_inputer: "John Doe",
    kdes: [
      {
        label: "Name of Farmer",
        value: "John Doe",
      },
      {
        label: "Location of farm",
        value: "Bogoso",
      },
      {
        label: "Date of harvest",
        value: "2021-09-01",
      },
      {
        label: "Quantity of harvest",
        value: "1000",
      },
      {
        label: "Unit of harvest",
        value: "kg",
      },
      {
        label: "Name of crop",
        value: "Cocoa",
      },
      {
        label: "Variety of crop",
        value: "Cocoa",
      },
      {
        label: "Date of harvest",
        value: "2021-09-01",
      },
    ],
  },
  {
    cte: "Transporting to Warehouse",
    assigned_inputer: "John Doe",
    kdes: [
      {
        label: "Location of Warehouse",
        value: "Accra",
      },
      {
        label: "Arrival Date",
        value: "2021-09-01",
      },
      {
        label: "Condition of harvest",
        value: "Good",
      },
    ],
  },
  {
    cte: "Processing",
    assigned_inputer: "John Doe",
    kdes: [],
  },
  {
    cte: "Packaging",
    assigned_inputer: "Fred Doe",
    kdes: [],
  },
  {
    cte: "Shipping",
    assigned_inputer: "Phoebe Doe",
    kdes: [],
  },
  {
    cte: "Completed",
    assigned_inputer: "Kwaku Doe",
    kdes: [],
  },
];

export const tracking = [
  {
    batch_number: "ES-23-322",
    product: "Cashew",
    flow: "Rosswood Cashew Flow",
    date: "2023-11-18",
    status: "Pending PROCESSING",
  },
  {
    batch_number: "KA-23-325",
    product: "Cocoa",
    flow: "Rosswood Cocoa Flow",
    date: "2023-11-21",
    status: "Pending TRANSPORTATION",
  },
];

export const assigned_kdes = [
  {
    label: "Name of Farmer",
    name: "name",
    type: "Text Input",
    isRequired: true,
    placeholder: "Enter KDE 1",
    options: [],
    helperText: "",
    value: "",
  },
  {
    label: "Location Farm",
    name: "farm_location",
    type: "Text Input",
    isRequired: true,
    placeholder: "Enter KDE 1",
    options: [],
    helperText: "",
    value: "",
  },
  {
    label: "Condition of harvest",
    name: "harvest_condition",
    type: "Select",
    isRequired: true,
    placeholder: "select",
    options: ["Good", "Bad"],
    helperText: "",
    value: null,
  },
  {
    label: "Description of harvest",
    name: "harvest_condition_explain",
    type: "Text Area",
    isRequired: false,
    placeholder: "text area",
    helperText: "Explain if the condition is not part of the options",
    value: "",
  },
  {
    label: "Date of harvest",
    name: "harvest_date",
    type: "Date",
    isRequired: true,
    placeholder: "Date",
    helperText: "Explain if the condition is not part of the options",
    value: null,
  },
  {
    label: "Some Check Example",
    name: "check_eg",
    type: "Checkbox",
    isRequired: true,
    placeholder: "",
    helperText: "This is a an example of a checkbox",
    value: false,
  },
  {
    label: "Some Switch Example",
    name: "switch_eg",
    type: "Switch",
    isRequired: true,
    placeholder: "",
    helperText: "This is a an example of a switch",
    value: false,
  },
  {
    label: "Multiple Select Example",
    name: "multiple_eg",
    type: "Multiselect",
    isRequired: true,
    placeholder: "Enter select",
    options: ["Good", "Bad", "Ugly", "Beautiful", "Nice"],
    helperText: "",
    value: null,
  },

  {
    label: "Number Input Example",
    name: "number_eg",
    type: "Number Input",
    isRequired: true,
    placeholder: "Enter number",
    options: [],
    helperText: "",
    value: null,
  },
];
